import { generatePath, useParams } from 'react-router-dom';
import { Button } from '@accure/ui';
import { Plus } from 'lucide-react';

import { Link } from '@/components/ui/link';
import { cls } from '@/utils/cls';

import { CapacityTestLegend } from './capacity-test-legend';
import { CapacityTestTable } from './capacity-test-table';

export type CapacityTestSidebarProps = {
  selectedId: string | undefined;
  setSelectedId: (itemId: string) => void;
  className?: string;
};

export function CapacityTestSidebar({
  selectedId,
  setSelectedId,
  className,
}: CapacityTestSidebarProps) {
  const { siteId } = useParams<{ siteId: string }>();

  return (
    <div className={cls('flex h-full flex-col p-4', className)}>
      <h2 className="mb-4 text-lg font-medium">Select a Capacity Test</h2>
      <div className="flex w-full flex-1 flex-col overflow-hidden">
        <div className="flex-1 overflow-y-auto rounded border border-zinc-400/20">
          <CapacityTestTable
            selectedId={selectedId}
            setSelectedId={setSelectedId}
          />
        </div>
        <div className="shrink-0 space-y-4 py-8">
          <Link
            to={generatePath('/asset/:siteId/capacity-test/new', { siteId })}
          >
            <Button variant="outline" className="w-full">
              <Plus /> Add new test
            </Button>
          </Link>
          <CapacityTestLegend />
        </div>
      </div>
    </div>
  );
}
